import type {PerseusCSProgramWidgetOptions} from "../../data-schema";

export function getCSProgramPublicWidgetOptions(
    options: PerseusCSProgramWidgetOptions,
): PerseusCSProgramWidgetOptions {
    return options;
}
